export default __webpack_public_path__ + "static/media/Inter-Italic.b89e547a.woff2";